import { render, staticRenderFns } from "./TxVariationSelect.vue?vue&type=template&id=bb15a47e&"
import script from "./TxVariationSelect.vue?vue&type=script&lang=js&"
export * from "./TxVariationSelect.vue?vue&type=script&lang=js&"
import style0 from "./TxVariationSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports